import axios from "axios";

export default defineNuxtPlugin(() => {
  const coreApi = axios.create({
    baseURL: useCurrentEnvironment().apiUrl,
  });

  coreApi.interceptors.response.use(
    (response) => response,
    async (error) => {
      const location = error.response?.data?.location;

      if (location) {
        await navigateTo(location, { external: true });
      } else {
        return Promise.reject(error);
      }
    }
  );

  return {
    provide: {
      coreApi
    }
  };
});